import { useState, useEffect } from "react";
import { Spin } from "antd";

import API from "scripts/api";
import Resources from "scripts/resources";

import PaperMan from "images/manwithpapers.png";
import GoldKey from "images/goldenkey.png";

const Component = () => {
  const initialState = {};
  const [state, setState] = useState(initialState);
  const { loaded, text } = state;

  const componentDidMount = () => {
    API.terms()
      .then(({ data }) => {
        setState((prevState) => ({
          ...prevState,
          ...data,
          loaded: true,
        }));
      })
      .catch();

    document.title = Resources.terms;
  };

  useEffect(componentDidMount, []);

  return loaded ? (
    <div className="page-terms">
      <div className="container">
        <img src={PaperMan} alt={Resources.terms} className="image" />
        <h1 className="heading">
          <img src={GoldKey} alt={Resources.goldenKey} />
          {Resources.terms}
        </h1>
        <div className="info" dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  ) : (
    <Spin className="page-loading" />
  );
};

export default Component;
